import { createUseStyles } from 'react-jss';
import { S, A } from '~/app/ui/tokens';

/** Shared by the AI guide screen and its editor. */
const useGuideStyles = createUseStyles({
  muted: { margin: '0 0 12px', fontSize: 13, lineHeight: 1.5, color: S.muted, maxWidth: 760 },
  steps: { display: 'grid', gap: 18 },
  step: { display: 'grid', gap: 8 },
  stepTitle: { margin: 0, fontSize: 14, fontWeight: 600 },
  instruction: {
    margin: 0,
    padding: '12px 14px',
    border: `1px solid ${S.line}`,
    borderRadius: A.radius,
    background: S.chrome,
    fontFamily: S.mono,
    fontSize: 13,
    lineHeight: 1.5,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    maxWidth: 760
  },
  row: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' },
  // What an assistant reads, as it reads it: plain text, wrapped, in a box that scrolls.
  guide: {
    margin: 0,
    maxHeight: 640,
    overflow: 'auto',
    padding: '14px 16px',
    border: `1px solid ${S.line}`,
    borderRadius: A.radius,
    background: S.field,
    fontFamily: S.mono,
    fontSize: 12,
    lineHeight: 1.55,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    color: S.fg
  },
  ok: { fontSize: 13, color: S.green, fontWeight: 600 },
  error: { fontSize: 13, color: S.red, lineHeight: 1.5 }
});

export default useGuideStyles;
